"use client";
import { StackProps, Text, VStack } from "@chakra-ui/react";

export interface CategoryGroupStatCardProps extends StackProps {
  title: string;
  stat: string;
  description: string;
}

export const CategoryGroupStatCard = (props: CategoryGroupStatCardProps) => {
  const { title, stat, description, ...rest } = props;
  return (
    <VStack
      align="center"
      background="white"
      p="15px 10px"
      border="2px"
      borderColor="white"
      wrap="wrap"
      w="220px"
      borderRadius="lg"
      flexWrap="wrap"
      spacing="2px"
      color="inherit"
      {...rest}
    >
      <Text fontWeight="bold" fontSize="md">
        {title}
      </Text>
      <Text
        fontWeight="bold"
        fontSize="2xl"
        align="center"
        fontFamily="numerical"
      >
        {stat}
      </Text>
      <Text align="center" color="gray.500" fontSize="sm">
        {description}
      </Text>
    </VStack>
  );
};
